import { Grid, Skeleton, Typography } from '@mui/material'

import useDates from '../../../../../utils/hooks/useDates'
import getNodeTypeMatrix from '../../../../../utils/nodetype-matrix'
import getUseCaseMatrix from '../../../../../utils/usecase-matrix'
import deviceClasses from '../../index.styles'

import DeviceInfoItem from './device-info-item'
import classes from './index.styles'

interface IProps {
  device: IDeviceType | null
}

const DeviceInfoSection = ({ device }: IProps) => {
  const { formatDateTime } = useDates()
  const phyLayerValue = device?.currentValues?.phy_layer?.value as string
  const slimNetworkType =
    phyLayerValue === 'lora'
      ? 'Sidewalk LoRa'
      : phyLayerValue === 'fsk'
        ? 'Sidewalk FSK'
        : phyLayerValue === 'ble'
          ? 'Sidewalk Bluetooth'
          : phyLayerValue === 'lorawan'
            ? 'LoRaWAN'
            : phyLayerValue === 'lte'
              ? 'LTE'
              : phyLayerValue === 'relay'
                ? 'Meshify Relay'
                : (phyLayerValue ?? 'No data')

  return (
    <Grid container={true} size={12} sx={deviceClasses.sectionOuterGrid}>
      <Grid container={true} size={12} sx={deviceClasses.sectionTitleGrid}>
        <Typography variant="subtitle1" sx={deviceClasses.sectionTitle}>
          {device ? 'Device Info' : <Skeleton width={60} />}
        </Typography>
      </Grid>

      {!device ? (
        <Grid container={true} size={12} sx={classes.deviceInfoItemContainer}>
          <DeviceInfoItem isLoading={true} />
          <DeviceInfoItem isLoading={true} />
          <DeviceInfoItem isLoading={true} />
          <DeviceInfoItem isLoading={true} />
          <DeviceInfoItem isLoading={true} />
          <DeviceInfoItem isLoading={true} />
          <DeviceInfoItem isLoading={true} />
        </Grid>
      ) : (
        <Grid container={true} size={12} sx={classes.deviceInfoItemContainer}>
          <DeviceInfoItem label="Last Check-In" value={device.lastCheckIn ? formatDateTime(device.lastCheckIn) : 'No data'} />
          {device.node.nodeTypeName === 'leak5s' && <DeviceInfoItem label="Network Type" value={slimNetworkType} />}
          {device.node.nodeTypeName !== 'leak5s' && device.node.nodeTypeName !== 'nbiot_leak' && (
            <DeviceInfoItem
              label={device.node.isGateway ? 'Gateway ID' : 'Connected to'}
              value={device.currentValues?.gatewayid?.value ? (device.currentValues?.gatewayid?.value as string) : 'No data'}
            />
          )}
          <DeviceInfoItem label="Name" value={device.node.vanity || 'No data'} />
          <DeviceInfoItem label="Type" value={device.node.nodeTypeName ? getNodeTypeMatrix[device.node.nodeTypeName] : 'No data'} />
          <DeviceInfoItem label="Monitoring" value={device.deviceUseCase ? getUseCaseMatrix[device.deviceUseCase] : 'No data'} />
          <DeviceInfoItem label="ID" value={device.node.uniqueId || 'No data'} />
          <DeviceInfoItem
            label="Firmware Version"
            value={device.firmwareVersion && device.firmwareVersion !== '<nil>' && device.firmwareVersion !== 'null' ? device.firmwareVersion : 'No data'}
          />
          {device.node.isV3 && <DeviceInfoItem label="Mute" value={device.node.mute ? 'Muted' : 'Not muted'} />}
        </Grid>
      )}
    </Grid>
  )
}

export default DeviceInfoSection
